<template>
  <div class="page-content homeworkPage">
    <p class="newMine_pageTitle newMine_pageTitleb m-b10">
      <span class="newMine_pageTitles">综合评价考试</span>
    </p>

    <!--  -->
    <div class="content">
      <el-form ref="form" :model="form" label-width="auto">
        <el-form-item label="考次" size="small" class="mb0">
          <el-select v-model="form.examConfigId" placeholder="请选择" @change="changeExamConfig">
            <el-option :label="item.name" :value="item.id" v-for="(item, index) in examConfigList"
              :key="index"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="courseList" v-for="(c, cindex) in list" :key="cindex">
        <div class="courseTitle d-flex d-flex-middle">
          <img src="../assets/gk/c_logo.png" alt="">
          {{ c.courseCode + '-' + c.courseName }}
          （{{ c.courseType | f('courseType') }}）
        </div>
        <div class="course_content">
          <div class="li" v-for="(item, index) in c.papers" :key="index">
            <div class=" d-flex d-flex-top">
              <img src="../assets/gk/p_logo.png" class="icon" />
              <p class="name txtOver" style="max-width: 550px;">{{ item.name }}</p>
            </div>
            <div class="topLi d-flex d-flex-middle d-flex-between">
              <div class="descBox d-flex d-flex-middle">
                <div class="descLi d-flex d-flex-middle">
                  <p class="color9">考试时间：</p>
                  <p class="color3">{{ item.startTime + ' 至 ' + item.endTime }}</p>
                </div>
              </div>
              <div class="btns d-flex d-flex-middle" v-if="getUseStatus(item) == '1'">
                <el-button type="warning" round @click="start({...item,...c})"
                  v-if="!item.status || item.status == 'NOTSTART'">开始考试</el-button>
                <el-button type="warning" round @click="start({...item,...c})"
                  v-else-if="item.status == 'STARTED'">继续考试</el-button>
                <template v-else>
                  <el-button type="primary" round v-if="item.doCountLimit>item.doneCount" @click="start({...item,...c})">重新考试</el-button>
                  <!-- <el-button type="primary" round @click="detail(item)">查看详情</el-button> -->
                </template>
              </div>
              <div class="btns d-flex d-flex-middle" v-else>
                <el-button type="info" round>{{ getUseStatus(item) == '0' ? '已结束' : '未开始' }}</el-button>
                <!-- <el-button type="primary" round @click="detail(item)"
                  v-if="getUseStatus(item) == '0' && item.examDataId">查看详情</el-button> -->
              </div>
            </div>

            <div class="descBox d-flex d-flex-middle">
              <div class="descLi d-flex d-flex-middle">
                <p class="color9">卷面总分：</p>
                <p class="color3">{{ item.totalScore }}分</p>
              </div>
              <div class="descLi d-flex d-flex-middle">
                <p class="color9">已考次数：</p>
                <span class="text-link" @click="detail(item, 1, c)">{{ item.doneCount || 0 }}次</span>
              </div>
              <div class="descLi d-flex d-flex-middle">
                <p class="color9">最高成绩：</p>
                <span class="text-link score-red">
                  <span v-if="item.doneCount === 0">未做</span>
                  <span v-else-if="item.highestScore || item.highestScore === 0" @click="detail(item, 2, c)">{{ item.highestScore }}分</span>
                  <span v-else>待公布</span>
                </span>
              </div>
            </div>

          </div>
          <Empty v-if="c.papers.length == 0"></Empty>
        </div>
      </div>
      <Empty v-if="list.length == 0"></Empty>

    </div>
    <div class="pagination">
      <el-pagination background layout="prev, pager, next" :page-size="form.size" :total="total"
        @current-change="changePage">
      </el-pagination>
    </div>
    <faceRecognition ref="faceRecognition" type="paper" @submit="toStart"></faceRecognition>
    <CourseOpenTip ref="courseOpenTip" />
    <FightersAgreementDialog
      ref="FightersAgreementDialog"
      @confirm="onPledgeConfirm"
    />
  </div>
</template>

<script>
import { mapState } from "vuex"
import { paperStatusMap } from '@/utils/enums'
import faceRecognition from "@/components/faceRecognition.vue";
import Empty from "@/components/Empty.vue";
import CourseOpenTip from '@/components/CourseOpenTip.vue'
import FightersAgreementDialog from "@/components/FightersAgreementDialog.vue";
import { getServerCurrentTime } from "@/utils/utils.js";
import { checkCourseOpened } from '@/utils/courseOpen';
export default {
  components: {
    faceRecognition,
    Empty,
    CourseOpenTip,
    FightersAgreementDialog,
  },
  data() {
    return {
      paperStatusMap,
      examConfigList: [],
      list: [],
      currentTime: null,
      form: {
        examConfigId: '',
        size: 10,
        current: 1,
        category: 'EXAMINE',
        status: 'ENABLE'
      },
      total: 0,
      // 
      activeData: {},
      currentServerTime: null
    };
  },
  computed: {
    ...mapState(['user'])
  },
  async mounted() {
    await this.refreshCurrentTime();
    this.getExamConfig()
  },
  methods: {
    async refreshCurrentTime () {
      this.currentTime = await getServerCurrentTime(this.$http)
    },
    getUseStatus(data) {
      const currentTime = this.currentServerTime || new Date();
      const start = new Date(data.startTime);
      const end = new Date(data.endTime);
      return currentTime < start ? '-1' : (currentTime >= start && currentTime <= end) ? '1' : '0';
    },
    async getExamConfig() {
      getServerCurrentTime(this.$http).then((currentTime) => {
        this.currentServerTime = currentTime;
        this.$http.get('/student/pc/getSchoolExamConfig', {}).then((res) => {
          this.examConfigList = res
          this.form.examConfigId = res[0].id
          this.getData();
        })
      });
    },
    changeExamConfig() {
      getServerCurrentTime(this.$http).then((currentTime) => {
        this.currentServerTime = currentTime;
        this.getData();
      });
    },
    async getData() {
      if (!this.form.examConfigId) return
      this.$http.get('/student/pc/study/promise/record/isSigned?examConfigId=' + this.form.examConfigId, {
      }).then((res) => {
        if (!res) {
          this.$refs.FightersAgreementDialog.open(this.form.examConfigId);
        } else {
          this.$http.get('/student/app/paper/list', this.form).then((res) => {
            this.list = res.records
            this.total = res.total
          })
        }
      })
    },
    changePage(e) {
      this.form.current = e
      getServerCurrentTime(this.$http).then((currentTime) => {
        this.currentServerTime = currentTime;
        this.getData();
      });
    },
    async start(row) {
      if (!checkCourseOpened(row.isOpen, this)) {
        return
      }
      this.activeData = row
      const _this = this
      // if (!this.form.examConfigId) {
      //   this.$message.error('请选择考次')
      //   return
      // }

      // try {
      //   const payRes = await this.$http.get('/student/pc/chooseCourse', {
      //     examConfigId: this.form.examConfigId,
      //     size: '99999'
      //   })
      //   const courseList = Array.isArray(payRes) ? payRes : (Array.isArray(payRes?.records) ? payRes.records : [])
      //   const currentCourseId = String(row.courseId || row.id || '')
      //   const targetCourse = courseList.find(item => String(item.courseId || item.id || '') === currentCourseId)

      //   if (!targetCourse || String(targetCourse.isPay) !== '1') {
      //     this.$message.error('该课程未缴费，暂不可开始考试')
      //     return
      //   }
      // } catch (error) {
      //   this.$message.error('获取缴费状态失败，请稍后重试')
      //   return
      // }

      this.$http.get('/student/pc/paper/canJoinExam', { courseId: row.courseId, paperId: row.id }).then((res) => {
        if (res.studyConfig&&res.studyConfig.openFaceRecognition == '1') { //人脸识别
          _this.$refs.faceRecognition.open({
            courseId: row.courseId,
            paperId: row.id
          })
        } else {
          _this.toStart()
        }
      })
    },
    toStart() {
      this.$http.post('/student/pc/paper/start', {
        paperId: this.activeData.id,
        examConfigId: this.form.examConfigId
      }).then((res) => {
        this.$router.push('/paper?type=EXAMINE&id=' + this.activeData.id + '&examDataId=' + res)
      })
    },
    detail(row, type, course) {
      if (!checkCourseOpened(course && course.isOpen, this)) {
        return
      }
      if (!row.doneCount) {
        return;
      }
      this.$router.push('/paperDetail?type=EXAMINE&id=' + row.id + '&examDataId=' + (row.examDataId||'') + '&myScore=' + (row.score||'') + '&examConfigId=' + this.form.examConfigId + '&viewType=' + type)
    },
    onPledgeConfirm() {
      this.getData();
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/variable.scss";
.txtOver {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: break-all;
}

.homeworkPage {
  .pageTitleBox {
    height: 80px;
    box-sizing: border-box;
    padding: 0 30px;

    .pageTitle {
      font-weight: bold;
      font-size: 18px;
      color: #333;
    }

    .mb0 {
      margin-bottom: 0;
    }
  }

  .tabs {
    width: 100%;
    height: 40px;
    background: $primary;

    p {
      width: 80px;
      text-align: center;
      margin: 0 30px;
      font-size: 16px;
      cursor: pointer;
      line-height: 40px;
      position: relative;
      color: rgb(51, 51, 51);
    }

    i {
      content: '';
      display: block;
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 20px;
      height: 4px;
      background-color: transparent;
      background: transparent;
    }

    .on {
      color: $primary;
    }

    .bgColor {
      background: $primary;
    }
  }

  .content {
    box-sizing: border-box;
    padding: 10px 50px;
    min-height: 450px;

    .courseList {
      margin-top: 15px;
      padding: 30px;
      background: #F7F9FC;
      border-radius: 15px 15px 15px 15px;
      border: 1px solid #E4EAF0;

      .courseTitle {
        font-weight: 400;
        font-size: 20px;
        color: #1A1A1A;
        vertical-align: middle;

        img {
          width: 28px;
          height: 28px;
          margin-right: 10px;
        }
      }
    }

    .course_content {
      margin-top: 15px;

      padding: 10px 30px;
      background: #FFFFFF;
      border-radius: 15px 15px 15px 15px;
    }

    .li {
      width: 100%;
      border-bottom: 1px solid #F2F2F2;
      box-sizing: border-box;
      padding: 20px 0;

      .topLi {
        line-height: 40px;
      }

      .icon {
        width: 18px;
        height: 18px;
        margin-right: 5px;
        position: relative;
        top: 2px;
      }

      .name {
        font-weight: 400;
        font-size: 16px;
        color: #1A1A1A;
      }

      .score {
        height: 20px;
        line-height: 20px;
        background: #FFA800;
        color: #fff;
        border-radius: 10px;
        margin-left: 10px;
        text-align: center;
        box-sizing: border-box;
        padding: 0 5px;
        font-size: 13px;
      }

      .btns {
        font-size: 16px;

        p {
          margin-left: 20px;
        }
      }

      .descBox {
        font-size: 14px;

        .descLi {
          margin-right: 50px;
        }
      }
    }

    .li:last-child {
      border-bottom: none;
    }

    .text-link {
      font-size: 14px;
      color: $primary;
      line-height: 20px;
      text-align: left;
      font-style: normal;
      text-decoration-line: underline;
      text-transform: none;
      cursor: pointer;
    }

    .score-red {
      color: #EA0000;
    }
  }

  .pagination {
    display: flex;
    justify-content: center;
    align-content: center;
    margin-bottom: 15px;
  }
}

.newMine_pageTitle {
  height: 80px;
  line-height: 80px;
  box-sizing: border-box;
  padding: 0 30px;
  font-weight: bold;
  font-size: 18px;
  color: #333;
}
</style>
